import React, { Component } from "react"
import { reduxForm, Field, Form } from "redux-form";
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from 'react-places-autocomplete';
import Button from 'react-bootstrap/Button';

import { getResultFromGeoPoint } from "../../actions/searchActions"
import store from "../../reducers/redux-index";

class OneLineSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            address: ""
        };
    }

    componentDidMount() {
        // Initialize with default search location without pre-filling the input
        const defaultAddress = "Gatineau, QC, Canada";
        store.dispatch({
            type: "SEARCH_ADDRESS",
            payload: {
                searchAddress: defaultAddress
            }
        })
        // Perform initial search with default location
        geocodeByAddress(defaultAddress).then(
            (info) => {
                getLatLng(info[0]).then(
                    (res) => {
                        const geoPoint = {
                            latitude: res.lat,
                            longitude: res.lng
                        }
                        getResultFromGeoPoint(geoPoint);
                    }
                )
            }
        )
    }

    handleChange = (address) => {
        this.setState({
            address
        });
        store.dispatch({
            type: "SEARCH_ADDRESS",
            payload: {
                searchAddress: address
            }
        })
    };

    onSubmit = () => {
        geocodeByAddress(this.state.address).then(
            (info) => {
                getLatLng(info[0]).then(
                    (res) => {
                        const geoPoint = {
                            latitude: res.lat,
                            longitude: res.lng
                        }
                        getResultFromGeoPoint(geoPoint);
                    }
                )
            }
        )
    }
    render() {
        const { handleSubmit } = this.props
        const searchOptions = {
            types: ['(cities)'],
            componentRestrictions: {
                country: ['ca']
            }
        }
        return (
            <div className="hero__search">
                <Form onSubmit={handleSubmit(this.onSubmit)}>
                    <InputGroup>
                        <PlacesAutocomplete
                            searchOptions={searchOptions}
                            value={this.state.address}
                            onChange={this.handleChange}
                        >
                            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                <div className="places-autocomplete-wrapper">
                                    <FormControl
                                        {...getInputProps({
                                            placeholder: 'Enter City ...',
                                            className: 'location-search-input',
                                        })}
                                    />
                                    <div className="autocomplete-dropdown-container">
                                        {loading && <div>Loading...</div>}
                                        {suggestions.map(suggestion => {
                                            const className = suggestion.active
                                                ? 'suggestion-item--active'
                                                : 'suggestion-item';
                                            // inline style for demonstration purpose
                                            const style = suggestion.active
                                                ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                                : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                            return (
                                                <div
                                                    {...getSuggestionItemProps(suggestion, {
                                                        className,
                                                        style,
                                                    })}
                                                >
                                                    <span>{suggestion.description}</span>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                        </PlacesAutocomplete>
                        <InputGroup.Append>
                            <Button type="submit" className="OneLineSearch__button">Search</Button>
                        </InputGroup.Append>
                    </InputGroup>
                </Form>
            </div>
        )
    }
}
export default OneLineSearch = reduxForm({
    form: "oneLineSearch"
})(OneLineSearch)